import React from "react"
import { AppDetailRouteComponentProps } from "../../RouteProps"
import { AppAuthCheck } from "../../../Components/Common/AuthCheck/AppAuthCheck"
import { AppCustomizeLLMParameters } from "../../../Components/Views/Dashboard/Sections/AppDetail/Customize/Modes/Parameters/LLMSettings"

export function AppCustomizeLLMParametersRoute({
    match
}: AppDetailRouteComponentProps) {
    return (
        <AppAuthCheck {...match.params} scope="llm-params:view">
            <AppCustomizeLLMParameters {...match.params} />
        </AppAuthCheck>
    )
}
